import { api } from "./authService";

export interface MasterAcademicPatternItem {
  id: string;
  name: string;
  code: string;
  pattern_type: "Annual" | "Semester" | "Trimester" | "Quarter" | string;
  credit_system: "Traditional" | "CBCS" | "NEP 2020" | "Choice Based" | "Credit Based" | string;
  semester_count: number;
  duration_years: number;
  grading_system: "Percentage" | "CGPA" | "GPA" | "Grade Letter" | string;
  attendance_rule: "75%" | "80%" | "85%" | "Custom" | string;
  description?: string;
  is_default: boolean;
  is_active: boolean;
  display_order: number;
  created_at?: string;
  updated_at?: string;
}

export const academicPatternService = {
  getAcademicPatterns: async (params?: {
    search?: string;
    is_active?: boolean;
    status?: string;
    pattern_type?: string;
    credit_system?: string;
    grading_system?: string;
  }): Promise<{ results: MasterAcademicPatternItem[] } | MasterAcademicPatternItem[]> => {
    const response = await api.get("/master/academic-patterns/", { params });
    return response.data;
  },

  createAcademicPattern: async (data: {
    name: string;
    code: string;
    pattern_type: string;
    credit_system: string;
    semester_count?: number;
    duration_years?: number;
    grading_system?: string;
    attendance_rule?: string;
    description?: string;
    is_default?: boolean;
    is_active?: boolean;
    display_order?: number;
  }): Promise<MasterAcademicPatternItem> => {
    const response = await api.post("/master/academic-patterns/", data);
    return response.data;
  },

  updateAcademicPattern: async (
    id: string,
    data: Partial<{
      name: string;
      code: string;
      pattern_type: string;
      credit_system: string;
      semester_count: number;
      duration_years: number;
      grading_system: string;
      attendance_rule: string;
      description: string;
      is_default: boolean;
      is_active: boolean;
      display_order: number;
    }>
  ): Promise<MasterAcademicPatternItem> => {
    const response = await api.patch(`/master/academic-patterns/${id}/`, data);
    return response.data;
  },

  deleteAcademicPattern: async (id: string): Promise<void> => {
    await api.delete(`/master/academic-patterns/${id}/`);
  },
};
